import { all } from "redux-saga/effects";
import {
  watchExportAssements,
  watchFetchAllUsers,
  watchFetchClassData,
  watchFetchCourseData,
  watchFetchUsersAnalytics,
  watchMount,
  watchUnmount,
} from "./watchers";

export function* classAnalyticsSagas() {
  yield all([
    watchExportAssements(),
    watchFetchAllUsers(),
    watchFetchClassData(),
    watchFetchCourseData(),
    watchFetchUsersAnalytics(),
    watchMount(),
    watchUnmount(),
  ]);
}
